import { WaterDamageProblems } from "raci-claims-home-general-damage-clientproxy";
import { MultiChoiceOption } from "raci-react-library";

export const waterDamageName = "waterDamageProblems";

export const waterDamageOptions = [
  {
    key: WaterDamageProblems.NoWaterDamage,
    label: "No water damage",
  },
  {
    key: WaterDamageProblems.SignificantMouldOrFungus,
    label: "Significant mould or fungus",
    sublabel: "Excludes surface staining or minor mould.",
  },
  {
    key: WaterDamageProblems.WaterDamageToTimberFlooring,
    label: "Water damage to timber flooring",
    sublabel: "Excludes floating laminate or vinyl floors.",
  },
  {
    key: WaterDamageProblems.BadlySoakedCarpets,
    label: "Carpet is so badly soaked that you can't dry it",
  },
  {
    key: WaterDamageProblems.HouseIsFlooded,
    label: "House is flooded",
  },
  {
    key: WaterDamageProblems.SewageOrDrainWaterInTheHouse,
    label: "There's sewage or drain water in the house",
  },
  {
    key: WaterDamageProblems.WaterInTheElectrics,
    label: "Water in the electrics",
    sublabel: "Water leaking into electrical switches or light fittings, some sparking",
  },
  {
    key: WaterDamageProblems.OtherWaterDamage,
    label: "Other water damage",
  },
] satisfies MultiChoiceOption[];
